import { keepPreviousData } from '@tanstack/react-query';

import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getAccounts, getCareDrivers, getRiders } from '../api/services/Incidents';
import { Account, CareDriver, Rider } from '../types/incidents';

export const useGetAccounts = (query, enabled) => {
  return useApiGet<Account>(['getAccounts', query], () => getAccounts(query), {
    placeholderData: keepPreviousData,
    enabled,
  });
};

export const useGetRiders = (query, enabled) => {
  return useApiGet<Rider>(['getRiders', query], () => getRiders(query), {
    placeholderData: keepPreviousData,
    enabled,
  });
};

export const useGetCareDrivers = (query, enabled) => {
  return useApiGet<CareDriver>(['getCareDrivers', query], () => getCareDrivers(query), {
    placeholderData: keepPreviousData,
    enabled,
  });
};
